/** Edits to a saved task, collected locally until the user saves. */

export const EMPTY_EDITS = { task: {}, steps: {}, deleted: [] };

export function editsReducer(state, action) {
  switch (action.type) {
    case 'editTask':
      return { ...state, task: { ...state.task, [action.field]: action.value } };
    case 'editStep':
      return {
        ...state,
        steps: {
          ...state.steps,
          [action.key]: { ...state.steps[action.key], [action.field]: action.value },
        },
      };
    case 'deleteStep':
      return state.deleted.includes(action.key)
        ? state
        : { ...state, deleted: [...state.deleted, action.key] };
    case 'discard':
      return EMPTY_EDITS;
    default:
      return state;
  }
}

export function countEdits(state) {
  const stepFields = Object.values(state.steps)
    .reduce((n, fields) => n + Object.keys(fields).length, 0);
  return Object.keys(state.task).length + stepFields + state.deleted.length;
}

/** Returns a graph with edits applied; deleted steps stay, flagged `deleted`. */
export function applyEdits(graph, state) {
  const steps = graph.steps.map((step) => {
    const fields = state.steps[step.key];
    const deleted = state.deleted.includes(step.key);
    if (!fields && !deleted) return step;
    return {
      ...step,
      ...fields,
      ...(fields ? { edited: true } : {}),
      ...(deleted ? { deleted: true } : {}),
    };
  });
  return { ...graph, steps };
}
